'use client';
import React, { useEffect, useState } from 'react';

interface BannerConfig {
    enabled: boolean;
    text: string;
    color: string;
}

const EnvironmentBanner: React.FC = () => {
    const [mounted, setMounted] = useState(false);
    const [config, setConfig] = useState<BannerConfig | null>(null);

    useEffect(() => {
        setMounted(true);

        const fetchConfig = async () => {
            try {
                const apiUrl = (process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000').replace(/\/+$/, '');
                const response = await fetch(`${apiUrl}/public/domain/environment-banner`);
                if (response.ok) {
                    const data = await response.json();
                    setConfig(data);
                }
            } catch (error) {
                console.error('Erro ao buscar configuração do banner de ambiente', error);
            }
        };

        fetchConfig();
    }, []);

    if (!mounted) return null;

    const isDev = process.env.NODE_ENV === 'development';
    const isStaging = process.env.NEXT_PUBLIC_APP_ENV === 'homologacao';

    // A API tem preferência
    if (config) {
        if (!config.enabled) return null;

        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 99999,
                    backgroundColor: config.color || '#f59e0b',
                    color: '#fff',
                    textAlign: 'center',
                    padding: '2px 0',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                    pointerEvents: 'none',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
            >
                {config.text || 'AMBIENTE DE HOMOLOGAÇÃO'}
            </div>
        );
    }

    // Fallback nativo
    if (!isDev && !isStaging) return null;

    const text = isDev ? 'AMBIENTE DE DESENVOLVIMENTO' : 'AMBIENTE DE HOMOLOGAÇÃO';

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 99999,
                backgroundColor: '#f59e0b', // amber-500
                color: '#fff',
                textAlign: 'center',
                padding: '2px 0',
                fontSize: '12px',
                fontWeight: 'bold',
                letterSpacing: '1px',
                pointerEvents: 'none',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
        >
            {text}
        </div>
    );
};

export default EnvironmentBanner;
